var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCopy = function SvgCopy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 28.947"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.421 0H2.632A2.64 2.64 0 0 0 0 2.632v18.421h2.632V2.632h15.789Zm3.947 5.263H7.895a2.64 2.64 0 0 0-2.632 2.632v18.421a2.64 2.64 0 0 0 2.632 2.632h14.473A2.64 2.64 0 0 0 25 26.316V7.895a2.64 2.64 0 0 0-2.632-2.632m0 21.053H7.895V7.895h14.473Z",
    "data-name": "Icon material-content-copy"
  })));
};
export default SvgCopy;